import { useNavigationState } from '@react-navigation/native'

export const useCanDismiss = () => {
  const routesForNbScreens = useNavigationState((state) => state.routes)

  const canDismissTo = (to: number) => routesForNbScreens && routesForNbScreens.length - 1 >= to

  return { canDismissTo }
}
